const PREFERRED_PRICE_DISPLAY = {
	price: 'PRICE',
	unitPrice: 'UNIT_PRICE',
};

export default PREFERRED_PRICE_DISPLAY;